import React from "react";
import { motion } from "framer-motion";
import { CtaPoints } from "../Data";

const Cta = ({ bgImage }) => {
  return (
    <section className="cta-section"
     style={{ "--cta-bg": `url(${bgImage})` }}>
      <div className="cta-container">

        {/* TOP CONTENT */}
        <div className="cta-top">
          <motion.p
            className="section-label"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            HOW WE WORK
          </motion.p>

          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 35 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            How We Manage Your Transportation
          </motion.h2>

          <motion.p
            className="section-text"
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            We manage your transportation with careful planning, the right vehicle
            selection, and seamless coordination from pickup to delivery, ensuring
            safe, timely, and hassle-free movement of your goods.
          </motion.p>
        </div>

        {/* MIDDLE GRID */}
        <motion.div
          className="cta-steps"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.2,
                delayChildren: 0.3,
              },
            },
          }}
        >
          {CtaPoints.map((item, index) => (
            <motion.div
              className="cta-step-card"
              key={index}
              variants={{
                hidden: {
                  opacity: 0,
                  y: 50,
                  scale: 0.9,
                },
                visible: {
                  opacity: 1,
                  y: 0,
                  scale: 1,
                  transition: {
                    duration: 0.7,
                    ease: [0.22, 1, 0.36, 1],
                  },
                },
              }}
              whileHover={{ y: -8, scale: 1.04 }}
              transition={{ type: "spring", stiffness: 220 }}
            >
              <motion.div
                className="step-number"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{
                  delay: 0.2,
                  type: "spring",
                  stiffness: 300,
                }}
              >
                {String(index + 1).padStart(2, "0")}
              </motion.div>

              <div className="step-content">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* BOTTOM CTA */}
        <motion.div
          className="cta-btn-wrap"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          viewport={{ once: true }}
        >
         <a href="/enquiry#enquiry-form">
  <motion.button
    className="primary-btn"
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
    transition={{ type: "spring", stiffness: 300 }}
  >
    Get a Quote
  </motion.button>
</a>
        </motion.div>

      </div>
    </section>
  );
};

export default Cta;
